import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { FeedingController } from '../controllers/Feeding';
import FeedingResults from './FeedingResults';
import { food_quantifiers, quantifiers_per_food, quantifiers_amounts } from '../constants';
import {
  //   Button,
  Modal,
  //   ModalHeader,
  //   ModalBody,
  //   ModalFooter,
  //   Form,
  //   FormGroup,
  //   Input,
  //   Label
} from "reactstrap";
import '../styles/feeding.css';
import axios from 'axios';


export const Menu = class Form extends Component {
  constructor() {
    super();
    this.state = {
      modals: {},
      menuData: {},
      tempMenuData: {},
      desease: false,
      save: false,
      n_advice: true,
      next: true,
      sickYes: false,
      sickNo: false,
      modal: false,
      results: false,
      onlyBreastresults: false,
      response: null,
    }
  }

  // onChange = (e) => {
  //   const state = this.state
  //   state[e.target.name] = e.target.value;
  //   this.setState(state);
  // }

  showFoodList = (food_list, feeding_options, translation) => {
    const breast_feeding = feeding_options.breast_feeding;
    const breast_frequency = feeding_options.breast_frequency;
    const meal_feeding = feeding_options.meal_feeding;
    const submit_button_label = translation['feeding_practice_food_info_submit_button'];
    const quantifier_label = translation['feeding_practice_food_info_quantifier_label'];
    const quantifier_empty_standard = translation['feeding_practice_food_info_quantifier_empty_standard'];
    const quantifier_empty_amount = translation['feeding_practice_food_info_quantifier_empty_amount'];
    const quantifier_empty_consistency = translation['feeding_practice_food_info_quantifier_empty_consistency'];
    const quantifier_save_button = translation['feeding_practice_food_info_save_button'];
    const quantifier_cancel_button = translation['feeding_practice_food_info_cancel_button'];
    var quantifiers_per_food_list = [];
    var food_quantifiers_list = [];
    var quantifiers_amounts_list = [];
    var consistency_options = [];
    var output = [];

    const selected = [];
    if (translation['language'] == 'swahili') {
      quantifiers_amounts.forEach((quantifier_amount) => {
        quantifiers_amounts_list.push(<option value={quantifier_amount['quantifier_amount_value']}>{quantifier_amount['quantifier_amount_name_swahili']}</option>);
      });
    }
    else {
      quantifiers_amounts.forEach((quantifier_amount) => {
        quantifiers_amounts_list.push(<option value={quantifier_amount['quantifier_amount_value']}>{quantifier_amount['quantifier_amount_name']}</option>);
      });
    }

    quantifiers_per_food_list = quantifiers_per_food.map((food_vs_quantifier) => {
      return food_vs_quantifier;
    });

    food_quantifiers_list = food_quantifiers.map((food_quantifier) => {
      return food_quantifier;
    });

    if (translation['language'] == 'swahili') {
      consistency_options.push(<option value='nyepesi'>Nyepesinyepesi</option>);
      consistency_options.push(<option value='ngumu'>Nzito</option>);
    }
    else {
      consistency_options.push(<option value='light'>light</option>);
      consistency_options.push(<option value='heavy'>heavy</option>);
    }


    var i = 0;
    food_list.forEach((food) => {
      i++;

      let j = i;

      let all_food_quantifiers = [];
      let quantifiers_list = [];
      const food_id = food.value;
      const food_name = food.label;

      quantifiers_per_food.forEach((food_vs_quantifier) => {
        if (food_vs_quantifier['food_id'] == food_id) {
          food_quantifiers.forEach((food_quantifier) => {
            let quantifiers = {};
            if (food_quantifier['food_quantifiers_id'] == food_vs_quantifier['food_quantifiers_id']) {
              if (translation['language'] == 'swahili')
                quantifiers.name = food_quantifier['food_quantifiers_name_swahili'];
              else
                quantifiers.name = food_quantifier['food_quantifiers_name'];
              quantifiers.weight = food_vs_quantifier['grams'];
              all_food_quantifiers.push(quantifiers);
            }
          });
        }
      });


      all_food_quantifiers.forEach((quantifier) => {
        quantifiers_list.push(<option value={quantifier.weight}>{quantifier.name}</option>);
      });

      const output_temp = (
        <form name="feeding_info_submit" onsubmit="return validateForm()">
          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div onClick={() => this.toggle(j)} id={`food${j}`} style={{ textAlign: "center", padding: "0px" }}><button type="button" style={{ textAlign: "center", width: "100%", height: "40px", backgroundColor: "#d3d3d3", color: "hsl(120, 50%, 40%)" }}>{food_name}</button></div>
              <span id={`error${j}`} style={{ color: "red" }}></span>
            </div>
          </div>
          <div className="row" style={{ width: "100%" }}>
            <div className="col-md-4 col-sm-4 col-xs-4" style={{ padding: "0px", width: "33.33%" }}>
              <div id={`quantity_div${j}`}>
                <input type="text" id={`quantity${j}`} name={`quantity${j}`} value={this.state.tempMenuData[`quantity${j}`]} style={{ width: "100%", textAlign: "center", height: "40px", border: "0px", outline: "none", fontSize: "0.7em" }} readonly="readonly" />
                <input type="text" value={this.state[`quantity_error${j}`]} style={{ color: "red", width: "100%", textAlign: "center", border: "0px", outline: "none", fontSize: "0.7em" }} readonly="readonly" />
              </div>
            </div>
            <div className="col-md-4 col-sm-4 col-xs-4" style={{ padding: "0px", width: "33.33%" }}>
              <div id={`quantity_frequency_div${j}`}>
                <input type="text" id={'quantity_frequency${j}'} name={`quantity_frequency${j}`} value={this.state.tempMenuData[`quantity_frequency${j}`]} style={{ width: "100%", textAlign: "center", height: "40px", border: "0px", outline: "none", fontSize: "0.7em" }} readonly="readonly" />
                <input type="text" value={this.state[`quantity_frequency_error${j}`]} style={{ color: "red", width: "100%", textAlign: "center", border: "0px", outline: "none", fontSize: "0.7em" }} readonly="readonly" />
              </div>
            </div>
            <div className="col-md-4 col-sm-4 col-xs-4" style={{ padding: "0px", width: "33.33%" }}>
              <div id={`consistency_div${j}`}>
                <input type="text" id={`consistency${j}`} name={`consistency${j}`} value={this.state.tempMenuData[`consistency${j}`]} style={{ width: "100%", textAlign: "left", height: "40px", border: "0px", outline: "none", fontSize: "0.7em" }} readonly="readonly" />
                <input type="text" value={this.state[`consistency_error${j}`]} style={{ color: "red", width: "100%", textAlign: "left", border: "0px", outline: "none", fontSize: "0.7em" }} readonly="readonly" />
              </div>
            </div>
          </div>

          <div className="col-md-12 col-sm-12 col-xs-12">
            {this.state.modals[`modal${j}`] ? (
              <Modal isOpen={true} toggle={() => this.toggle(j)} style={{ padding: "0px", margin: "0px", marginTop: "195px" }} id={`food_quantifier${j}`}>
                <div className="modal-dialog" style={{ padding: "0px", margin: "0px" }}>
                  <div className="col-md-12 col-sm-12 col-xs-12" style={{ padding: "0px", margin: "0px" }}>
                    <div className="modal-content" style={{ marginTop: "", borderRadius: "0px", backgroundColor: "hsl(120, 50%, 40%)" }}>
                      <div className="modal-header">
                        <div className="modal-title" style={{ textAlign: "center" }}>{food_name}</div>
                      </div>
                      <div className="modal-body">
                        <div class="form-group">
                          <select onChange={this.onInputChange} id={`quantity${j}`} name={`quantity${j}`} style={{ width: "100%", height: "30px" }}>
                            <option value="">{quantifier_empty_standard}</option>
                            {quantifiers_list.map((quantifier) => quantifier)}
                          </select>
                        </div>
                        <div className="form-group">
                          <select onChange={this.onInputChange} id={`quantity_frequency${j}`} name={`quantity_frequency${j}`} style={{ width: "100%", height: "30px" }}>
                            <option value="">{quantifier_empty_amount}</option>
                            {quantifiers_amounts_list.map((amount) => amount)}
                          </select>
                        </div>
                        <div className="form-group">
                          <select onChange={this.onInputChange} id={`consistency${j}`} name={`consistency${j}`} style={{ width: "100%", height: "30px" }}>
                            <option value="">{quantifier_empty_consistency}</option>
                            {consistency_options.map((consistency) => consistency)}
                          </select>
                        </div>
                        <div className="form-group">
                          <select onChange={this.onInputChange} id={`time${j}`} name={`time${j}`} style={{ width: "100%", height: "30px" }}>
                            <option>Chagua mda uliomlisha</option>
                            <option value="Asubuhi">Asubuhi</option>
                            <option value="Mchana">Mchana</option>
                            <option value="Jioni">Jioni</option>
                            <option value="Usiku">Usiku</option>
                          </select>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button onClick={() => this.toggle(j)} data-dismiss="modal" style={{ marginRight: "20px", height: "30px", width: "70px" }}>{quantifier_cancel_button}</button>
                        <button onClick={() => this.onInputSave(j)} data-dismiss="modal" style={{ height: "30px", width: "70px" }} id={`food_list_info${j}`}>{quantifier_save_button}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>
            ) : null}
          </div>
          <input type="hidden" className="form-control" name={`food_name${j}`} value={food_name} />
          <input type="hidden" className="form-control" name={`food_id${j}`} value={food_id} />
        </form>
      );
      output.push(output_temp);
    });
    output.push(<input onClick={() => this.onMenuSubmit(i)} type="submit" name="feeding" value={submit_button_label} style={{ float: "right", margin: "10px", width: "100px", height: "40px", backgroundColor: "hsl(120, 50%, 40%)", color: "#fff" }} />);
    //   $this->output .= <<<_END
    // <input type="hidden" class="form-control" id="total_no" name="total_no" value="$j" >
    // <input type="hidden" class="form-control" name="breast_feeding" value="$breast_feeding" >
    // <input type="hidden" class="form-control" name="breast_frequency" value="$breast_frequency" >
    // <input type="hidden" class="form-control" name="meal_feeding" value="$meal_feeding" >
    // <div class="form-group">
    // <input type="submit" name="feeding" value="$submit_button_label" style="float: right;margin: 10px;width: 100px;height: 40px;background-color: hsl(120, 50%, 40%);color: #fff;">
    // </div>
    // _END;

    // if($option == 'Yes'){

    // }
    // else
    //   $this->output = '';

    return output;
  }


  onInputChange = (e) => {
    const state = this.state
    let { name, value, options, selectedIndex } = e.target;
    state[name] = options[selectedIndex].text;
    state.menuData[name] = value;
    this.setState(state);
  }

  onInputSave = (no) => {
    const state = this.state
    if (state[`quantity${no}`] !== null)
      state.tempMenuData[`quantity${no}`] = state[`quantity${no}`];
    if (state[`quantity_frequency${no}`] !== null)
      state.tempMenuData[`quantity_frequency${no}`] = state[`quantity_frequency${no}`];
    if (state[`consistency${no}`] !== null)
      state.tempMenuData[`consistency${no}`] = state[`consistency${no}`];
    if (state[`time${no}`] !== null)
      state.tempMenuData[`time${no}`] = state[`time${no}`];
    this.setState(state);
    this.toggle(no);
  }

  toggle = (no) => {
    const modals = this.state.modals;
    modals[`modal${no}`] = !this.state.modals[`modal${no}`];
    this.setState({ modals: modals });
  };


  initializeData = () => {
    const state = this.state
    const { food_list, feeding_options, Translator } = this.props;
    const count_limit = food_list.length;
    var count = 0;

    food_list.forEach((food) => {
      count++;

      state.modals[`modal${count}`] = false;
      state.menuData[`food_name${count}`] = food.label;
      state.menuData[`food_id${count}`] = food.value;
      state.tempMenuData[`quantity${count}`] = Translator['feeding_practice_food_info_standard_placeholder'];
      state.tempMenuData[`quantity_frequency${count}`] = Translator['feeding_practice_food_info_amount_placeholder'];
      state.tempMenuData[`consistency${count}`] = Translator['feeding_practice_food_info_consistency_placeholder'];

      state[`quantity${count}`] = null;
      state[`quantity_frequency${count}`] = null;
      state[`consistency${count}`] = null;
      state[`time${count}`] = null;
    });

    state.menuData.breast_feeding = feeding_options.breast_feeding;
    state.menuData.breast_frequency = feeding_options.breast_frequency;
    state.menuData.meal_feeding = feeding_options.meal_feeding;
    state.menuData.total_no = count;

    this.setState(state);

    if (this.props.onlyBreastFed)
      this.onBreastSubmit();
  }

  validateInputs = (no) => {
    const state = this.state
    let error = false;
    const translation = this.props.Translator;
    var count;
    for (count = 1; count <= no; count++) {
      if (state.tempMenuData[`quantity${count}`] == translation['feeding_practice_food_info_standard_placeholder']) {
        state[`quantity_error${count}`] = translation['feeding_practice_food_info_no_standard_error'];
        error = true;
      }
      else
        state[`quantity_error${count}`] = '';

      if (state.tempMenuData[`quantity_frequency${count}`] == translation['feeding_practice_food_info_amount_placeholder']) {
        state[`quantity_frequency_error${count}`] = translation['feeding_practice_food_info_no_amount_error'];
        error = true;
      }
      else
        state[`quantity_frequency_error${count}`] = '';

      if (state.tempMenuData[`consistency${count}`] == translation['feeding_practice_food_info_consistency_placeholder']) {
        state[`consistency_error${count}`] = translation['feeding_practice_food_info_no_consistency_error'];
        error = true;
      }
      else
        state[`consistency_error${count}`] = '';
    }

    if (error) {
      this.setState(state);
      return false;
    }
    else {
      this.setState(state);
      return true;
    }

  }

  onBreastSubmit = () => {
    this.props.showTitle();
    const results = FeedingController.getBreastFeedingStatus(this.props.feeding_options, this.props.Child, this.props.User, this.props.age, this.props.Translator);
    // alert(results);
    this.setState({ response: results, results: true, onlyBreastresults: true });
  }

  generateNutritionPrompt(data, child) {
    let mlo = [];
    let totalMeals = data.total_no || 0;

    for (let i = 1; i <= totalMeals; i++) {
      if (data[`food_name${i}`]) {
          mlo.push(`
        #### Mlo wa ${i}:
        - **Jina la Chakula:** ${data[`food_name${i}`].trim()}
        - **Kiasi:** ${data[`quantity${i}`] || "Haijatajwa"}
        - **Marudio:** ${data[`quantity_frequency${i}`] || "Haijatajwa"}
        - **Wakati:** ${data[`time${i}`] || "Haijatajwa"}
        - **Uthabiti:** ${data[`consistency${i}`] || "Haijatajwa"}
      `);
      }
    }

    return `
        Kwa kuzingatia taarifa za lishe zilizotolewa hapa chini, toa ushauri wa kina wa lishe kwa mtoto kulingana na chakula alichokula. Zingatia uthabiti wa chakula, mara ngapi anakula, kiasi cha chakula, na kama ananyonya. Pia, angazia changamoto zozote zinazoweza kutokea na mapendekezo ya mlo bora.

        ### Taarifa za Lishe:
        - **Unyonyeshaji:** ${data.breast_feeding}
        - **Mara ngapi ananyonya:** ${data.breast_frequency}
        - **Jumla ya Milo:** ${totalMeals}

        ${mlo.join("\n")}

        ### Taarifa za Ziada:
        - **Jina la mtoto?** ${child?.first_name} ${child?.middle_name} ${child?.last_name}
        - **Tarehe ya kuzaliwa ya mtoto?** ${child?.birth_date}
        - **Jinsia ya mtoto?** ${child?.sex == "F" ? "Wakike" : "Wakiume"}
        - **Je, mtoto ni mgonjwa?** ${data.sickYes ? "Ndio" : "Hapana"}
        - **Je, ameshawahi kupokea ushauri wa lishe?** ${data.n_advice ? "Ndio" : "Hapana"}
        - **Je, ananyonya pekee bila kula chakula kingine?** ${data.onlyBreastresults ? "Ndio" : "Hapana"}

        **Kwa kuzingatia taarifa hizi, toa:**
        1. Tathmini ya jumla kuhusu lishe ya mtoto.
        2. Mapungufu au maeneo yanayohitaji kuboreshwa.
        3. Mapendekezo ya vyakula vya ziada au maboresho kwenye lishe.
        4. Muhtasari wa kama lishe hii ni bora na inatosha kwa ukuaji mzuri wa mtoto.
    `;
  }

  onMenuSubmit = async (no) => {
    let results;
    if (this.validateInputs(no)) {
      this.props.showTitle();
      results = FeedingController.getFeedingStatus(this.state.menuData, this.props.Child, this.props.User, this.props.age, this.props.Translator);
      // console.log(this.state)
      // console.log(this.props)
      const prompt = this.generateNutritionPrompt(this.state.menuData, this.props.Child)

      // const gender = this.props.Child['sex'] == "F" ? "wakike" : "wakiume"
      // const child_name = this.props.Child['first_name']
      // const dob = this.props.Child['birth_date']
      // const feeding = this.state.menuData['breast_feeding'] == "Hapana" ? "simnyonieshi" : `namnyonyesha mara ${this.state.menuData['breast_frequency']} kwa siku`
      // const food = this.state.menuData['food_name1']
      // const is_feeding = this.state.menuData['meal_feeding'] == "Ndiyo"
      // const food_qty = this.state.menuData[`quantity_frequency1`]

      // const prompt = `
      // Nina mtoto mtoto wa ${gender} anayeitwa ${child_name}, alizaliwa tarehe ${dob} ${feeding}, ${is_feeding ? `na mara nyingi humpa ${food_qty} cha ${food} kwa siku` : ""}, Kutokana na lishe hii, tafadhali hesabu jumla ya nishati (KCal) na protini (g) anayopata.
      // Linganisha na kiwango kinachopendekezwa kwa mtoto wa umri wake (900 KCal na 1.17g ya protini kwa siku).

      // Toa majibu katika muundo ufuatao:

      // Eleza kiasi cha nishati na protini anachopata kwa sasa.
      // Bainisha upungufu wa nishati na protini.
      // Toa ushauri kuhusu mara ngapi anapaswa kulishwa kwa siku.
      // Taja kuwa mlo wa sasa si kamili na pendekeza kuongeza angalau makundi matatu ya vyakula kutoka kwenye orodha fulani ili kukamilisha mlo.
      // Toa maelekezo ya kuchagua chakula kimoja kwa kila kundi na kubonyeza kitufe ili kupata mpangilio wa mlo.
      // Hakikisha jibu ni fupi, sahihi, na linazingatia muundo huu.
      // Anza kwa kutaja jina la mtoto
      // `


      const response = await axios.post("https://api.smartgrowthdiary.co.tz/assistant/get-suggestions/", {
        "message": prompt
      }, {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true  // Add this if you're using authentication
      });

      // fetch("http://127.0.0.1:8000/assistant/get-suggestions/",{
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify({
      //     "message": prompt
      //   }),
      // })

      results['gpt'] = response?.data?.message

      this.setState({ response: results, results: true });
    }
    else
      this.setState({ results: false });
  }


  componentDidMount() {
    this.initializeData();
    this.props.showFeedingInst(false);
  }

  render() {
    const { food_list, feeding_options, Translator, Child, age } = this.props;
    const feeding_menu = this.showFoodList(food_list, feeding_options, Translator);

    return (
      !this.state.results ? feeding_menu.map((menu) => menu) : (
        <FeedingResults response={this.state.response} Translator={Translator} Child={Child} age={age} feeding_options={feeding_options} />
      )
    );
  }
}

export default Menu;